import axios from '@/http/axios/index.js'


export default {
    getEntities(data) {
        return axios.get('budget/assign/entities')
    },
    getDepartaments(data) {
        return axios.get('budget/assign/departaments')
    },
    getYears(data) {
        return axios.get('budget/assign/years')
    },
    list(data) {
        return axios.get('budget/assign/list', { params: data })
    },
    budgetDetails(data){
        return axios.get('budget/assign/details', { params: data })
    },
    budgetUpdate(payload){
        return axios.post('budget/assign/update', payload)
    }
}




